var reactIs_production = {};

export { reactIs_production as __exports };
//# sourceMappingURL=react-is.production.mjs.map
